
const specialCharacterConstrains = (isRequired = true,ErrorMessageForIsRequired,otherValidations={}) => {
  return (
    { required: {
        value: isRequired,
        message: ErrorMessageForIsRequired,
      } ,
      pattern: {
        value: /^[^"'<>&]+$/,
        message: 'Special characters are not allowed',
      } ,
      ...otherValidations
    }
  )
}

export default specialCharacterConstrains
